<template>
  <!-- add flex-direction: column; in tailwind css -->
  <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-10">
    <p class="font-general-semibold text-2xl sm:text-5xl font-semibold mb-2 text-ternary-dark dark:text-ternary-light">
      {{ $t('linkAbout') }}
    </p>
  </div>

  <div class="block sm:flex sm:justify-center flex-row items-center sm:gap-10">
    <div class="w-full sm:w-1/4 mb-7 sm:mb-0 flex justify-center sm:justify-start">
      <img :src="require('@/assets/images/pf_v2.jpg')" class="rounded-xl w-96" alt="Profile Picture" />
    </div>

    <div class="w-full sm:w-3/4 text-left">
      <p 
        class="font-general-regular mb-4 text-ternary-dark dark:text-ternary-light text-lg">
        {{ $t('bioText1') }}
      </p>
      <p 
        class="font-general-regular mb-4 text-ternary-dark dark:text-ternary-light text-lg">
        {{ $t('bioText2') }}
      </p>
      <p 
        class="font-general-regular mb-4 text-ternary-dark dark:text-ternary-light text-lg">
        {{ $t('bioText3') }}
      </p>
    </div>
  </div>
  <div class="mt-16">
    <h2 class="text-2xl font-semibold text-ternary-dark dark:text-ternary-light mb-4">
      {{ $t('aboutTechStack') }}
    </h2>
    <div class="flex justify-center flex-wrap gap-4">
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">Vue.js</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">React</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">TypeScript</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">SCSS</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">WordPress</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">Figma</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">PHP</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">Node.js</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">Python</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">MySQL</span>
      <span class="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">HTML/ CSS</span>
    </div>
  </div>

  <div class="mt-16">
    <h2 class="text-2xl font-semibold text-ternary-dark dark:text-ternary-light mb-4">
      {{ $t('aboutAdobe') }}
    </h2>
    <div class="flex justify-center flex-wrap gap-4">
      <span class="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Photoshop</span>
      <span class="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Illustrator</span>
      <span class="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">InDesign</span>
      <span class="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">After Effects</span>
      <span class="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Premiere Pro</span>
      <span class="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">XD</span>
    </div>
  </div>

  <div class="mt-16">
    <h2 class="text-2xl font-semibold text-ternary-dark dark:text-ternary-light mb-4">
      {{ $t('aboutCareer') }}
    </h2>
    <div class="space-y-6 border-l-4 border-cyan-500 pl-6">
      <div>
        <p class="text-sm text-gray-500 dark:text-gray-400">2018 - 2019</p>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ $t('CareerName1') }}
        </h3>
        <p class="text-gray-700 dark:text-gray-300">
          {{ $t('CareerText1') }}
        </p>
      </div>
      <div>
        <p class="text-sm text-gray-500 dark:text-gray-400">2020 - 2021</p>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ $t('CareerName2') }}
        </h3>
        <p class="text-gray-700 dark:text-gray-300">
          {{ $t('CareerText2') }}
        </p>
      </div>
      <div>
        <p class="text-sm text-gray-500 dark:text-gray-400">2021 - 2022</p>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ $t('CareerName3') }}
        </h3>
        <p class="text-gray-700 dark:text-gray-300">
          {{ $t('CareerText3') }}
        </p>
      </div>
      <div>
        <p class="text-sm text-gray-500 dark:text-gray-400">2022 - 2025</p>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ $t('CareerName4') }}
        </h3>
        <p class="text-gray-700 dark:text-gray-300">
          {{ $t('CareerText4') }}
        </p>
      </div>
      <div>
        <p class="text-sm text-gray-500 dark:text-gray-400">2025 ~</p>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ $t('CareerName5') }}
        </h3>
        <p class="text-gray-700 dark:text-gray-300">
          {{ $t('CareerText5') }}
        </p>
      </div>
    </div>
  </div>

  <!-- CTA -->
  <div class="mt-16 text-center">
    <h2 class="text-2xl font-semibold text-ternary-dark dark:text-ternary-light mb-4">
      {{ $t('aboutMessage') }}
    </h2>
    <p class="text-lg text-gray-600 dark:text-gray-300 mb-6">
      {{ $t('aboutMessage2') }}
    </p>
    <a href="#contact" class="inline-block px-6 py-3 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg transition duration-300">
      {{ $t('aboutContact') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'AboutMe',
};
</script>